import { render, staticRenderFns } from "./IbxButtonList.vue?vue&type=template&id=f8694b5c"
import script from "./IbxButtonList.vue?vue&type=script&lang=js"
export * from "./IbxButtonList.vue?vue&type=script&lang=js"
import style0 from "./IbxButtonList.vue?vue&type=style&index=0&id=f8694b5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports